export default "__VITE_ASSET__D0Tvrsvr__"